<script setup lang="ts">
import { type DeviceHubCard, EHubProvider } from '@/types/enum/HubProviderEnum'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { DividerItem, StackLayout } from '@rfc/rfc-components-library'
import { EOrientation } from '@rfc/rfc-components-library/types'
import { inject } from 'vue'
import DeviceCardAssociated from './DeviceCardAssociated.vue'
import DeviceRentalDateInformations from './DeviceRentalDateInformations.vue'
import DeviceTimerEvent from './DeviceTimerEvent.vue'

type Props = {
    data?: DeviceModel
}
defineProps<Props>()

const { hideAssociated } = inject<DeviceHubCard>(EHubProvider.DEVICES_HUB_CARD, {
    hideAssociated: false
})
</script>

<template>
    <StackLayout direction="column" class="px-2 pb-2 w-full">
        <StackLayout
            direction="column"
            :class="`flex-wrap justify-between gap-x-2 pr-1 w-full h-full ${data?.rental ? 'align-content-center' : 'px-4'}`">
            <div class="left-side-footer">
                <DeviceCardAssociated
                    v-if="!hideAssociated"
                    :data="data"
                    class="align-self-start" />
                <DeviceTimerEvent :data="data" class="align-self-start" />
            </div>
        </StackLayout>
        <template v-if="!!data?.rental || !!data?.unavailability_periods?.periods?.length">
            <DividerItem :orientation="EOrientation.HORIZONTAL" class="footer-divider w-full" />
            <DeviceRentalDateInformations
                :data="data"
                :class="`${hideAssociated ? '' : 'pl-1'} w-full`" />
        </template>
    </StackLayout>
</template>

<style scoped lang="scss">
.left-side-footer {
    width: 100%;
}
.footer-divider {
    &.vertical-hr {
        height: 100%;
    }
}
</style>
